export const Features = {
  AdvancedFilters: 'AdvancedFilters',
  Selection: 'Selection',
  SessionCreation: 'SessionCreation',
  Folders: 'Folders',
  FolderCreation: 'FolderCreation',
}
